import { createApp } from 'vue'
import axios from 'axios'

window.pawine = window.pawine || {}

const app = createApp({
  data() {
    return {
      videos: window.pawine.videos || [],
      categories: window.pawine.categories || [],
      selectedCategory: null,
    }
  },
  computed: {
    filteredVideos() {
      if (! this.selectedCategory) {
        return this.videos
      }

      return this.videos.filter(video => video.categorySlug == this.selectedCategory)
    },
  },
  methods: {
    setCategory(slug) {
      if (this.selectedCategory == slug) {
        this.selectedCategory = null
      } else {
        this.selectedCategory = slug
      }
    },
  }
})

app.mount('#videos-index')
